import { AuthUser, OrgSettings } from '@app/account/account-api.model';

export const isSkillsClient = (
  authUser: AuthUser,
  settings?: OrgSettings
): boolean => {
  const isSkillsClient =
    settings?.skillInventoryClient ||
    settings?.skillAnalyticsClient ||
    authUser.isSkillAnalyticsClient ||
    authUser.isSkillInventoryClient;

  return isSkillsClient;
};

export const isUserAPathwayCollaborator = (
  authUser: AuthUser,
  pathwayAuthorProfileKeys?: number[]
): boolean => {
  const isCollaborator = pathwayAuthorProfileKeys?.includes(
    authUser.viewerProfile.userProfileKey
  );
  return isCollaborator;
};

export const nonChannelBulkPathwaysPermissions = (
  authUser: AuthUser,
  useGranularContentPermissions: boolean
): {
  canBulkEditVisibility: boolean;
  canBulkAddCollaborators: boolean;
  canBulkDeletePathways: boolean;
  canBulkEndorsePathways: boolean;
} => ({
  canBulkEditVisibility: useGranularContentPermissions
    ? authUser.defaultOrgInfo?.permissions.addOrganizationPathways &&
      authUser.defaultOrgInfo?.permissions.updateOrganizationPathways
    : true,
  canBulkAddCollaborators: useGranularContentPermissions
    ? authUser.defaultOrgInfo?.permissions.updateOrganizationPathways
    : true,
  canBulkDeletePathways: useGranularContentPermissions
    ? authUser.defaultOrgInfo?.permissions.deleteOrganizationPathways
    : true,
  canBulkEndorsePathways: useGranularContentPermissions
    ? authUser.defaultOrgInfo?.permissions.updateOrganizationPathways &&
      authUser.canEndorseContent
    : authUser.canEndorseContent,
});

export const canViewPathwayInsights = (
  authUser: AuthUser,
  pathwayAuthorProfileKeys: number[]
): boolean => {
  const { addOrganizationPathways, updateOrganizationPathways, viewReports } =
    authUser.defaultOrgInfo.permissions;
  return (
    isUserAPathwayCollaborator(authUser, pathwayAuthorProfileKeys) ||
    addOrganizationPathways ||
    updateOrganizationPathways ||
    viewReports
  );
};
